import { render, staticRenderFns } from "./TopBtn.vue?vue&type=template&id=2f3e6e0c"
import script from "./TopBtn.vue?vue&type=script&lang=js"
export * from "./TopBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports